module.exports = __webpack_public_path__ + "media/images/soar/home_page_figure3-ec39d4514af6de342b19de383a8b1f94.png";